import React from "react"
import styled from "@emotion/styled"
import HomepageBanner from "components/Homepage/homepageBanner"
import WhatsNew from "components/Homepage/whatsNew"
import { graphql, useStaticQuery } from "gatsby"
import OurServices from "components/Homepage/ourServices"
import OurTeam from "components/Homepage/ourTeam"
import OurCompany from "components/Homepage/ourCompany"
import Resources from "components/Homepage/resources"
import Journey from "components/Homepage/journey"

const PageWrapper = styled.div`
    position: relative;
    color: #ffffff;
    & h2.header-title {
        border-left: ${(props) => props.theme.colors.primary} double;
        border-width: 4px 4px 0 4px;
        box-shadow: -3px 0 0 0 ${(props) => props.theme.colors.primary};
        padding-left: 0.5rem;
        line-height: 0.75;
        margin-left: -1.2rem;
        font-weight: normal;
        margin-bottom: 1rem;
    }
`

const query = graphql`
    {
        banner: strapiPage(
            slug: { eq: "wns-homepage" }
            company: { shortname: { eq: "WNS" } }
        ) {
            title
            menu_title
            description
            metadata {
                description
                title
                OG_type
                OG_image {
                    publicURL
                    name
                    childImageSharp {
                        resize(width: 1200, height: 630, cropFocus: CENTER) {
                            src
                        }
                    }
                }
            }
            content {
                title
                Banner_Header_1
                Banner_Header_2
            }
            image {
                publicURL
            }
        }
        pageContent: allStrapiPage(filter: { slug: { eq: "wns-homepage" } }) {
            edges {
                node {
                    content {
                        Single_Column {
                            title
                            content
                        }
                        Multi_Columns {
                            content
                            title
                        }
                        Text_With_Image {
                            Image_Size
                            Layout_Type
                            content
                            title
                            image {
                                childImageSharp {
                                    gatsbyImageData(
                                        placeholder: DOMINANT_COLOR
                                        backgroundColor: "#f2f2f2"
                                    )
                                    original {
                                        width
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
        programmes: allStrapiPost(
            filter: { category: { slug: { eq: "programmes-and-events" } } }
            sort: { fields: createdAt, order: DESC }
            limit: 1
        ) {
            edges {
                node {
                    id
                    createdAt
                    title
                    slug
                    image {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: BLURRED
                                height: 300
                                width: 640
                            )
                        }
                    }
                }
            }
        }
        promotions: allStrapiPost(
            sort: { fields: createdAt, order: DESC }
            limit: 2
            filter: {
                Post_Type: { eq: "Promotions" }
                slug: { ne: "dummy-data-do-not-pull" }
            }
        ) {
            edges {
                node {
                    id
                    createdAt
                    title
                    slug
                    image {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: BLURRED
                                height: 300
                                width: 640
                            )
                        }
                    }
                }
            }
        }
        resources: allStrapiArticle(
            sort: { fields: published_date, order: DESC }
            filter: {
                category: { slug: { eq: "resources" } }
                Post_Type: { eq: "Blog_Post" }
            }
            limit: 3
        ) {
            edges {
                node {
                    summary
                    Description
                    category {
                        name
                        slug
                    }
                    menu_title
                    slug
                    title
                    image {
                        childImageSharp {
                            gatsbyImageData(
                                placeholder: DOMINANT_COLOR
                                width: 400
                                height: 400
                            )
                        }
                    }
                    author {
                        name
                    }
                    tags {
                        name
                        slug
                    }
                    published_date
                }
            }
        }
    }
`

// markup
const IndexPage = () => {
    const data = useStaticQuery(query)
    const { promotions, programmes, pageContent, resources, banner } = data
    const dataWhatsnew = { edges: [...promotions.edges, ...programmes.edges] }
    let whatNewsDesc = null

    let [servicesObj, ourTeamObj] = Array(2).fill({
        title: null,
        content: null,
        imageFile: null,
    })

    let [desc, resourcesDesc, companyDesc] = Array(3).fill(null)

    pageContent.edges.length &&
        pageContent.edges[0].node.content.map((page) => {
            if (page.Single_Column !== null) {
                const title = page.Single_Column.title.toLowerCase()
                if (title.includes("whats")) {
                    whatNewsDesc = page.Single_Column.content
                } else if (title.includes("description")) {
                    desc = page.Single_Column.content
                } else if (title.includes("resources")) {
                    resourcesDesc = page.Single_Column.content
                } else if (title.includes("companies")) {
                    companyDesc = page.Single_Column.content
                }
            } else if (page.Text_With_Image) {
                const title = page.Text_With_Image.title.toLowerCase()
                const obj = {
                    title: page.Text_With_Image.title,
                    content: page.Text_With_Image.content,
                    imageFile: page.Text_With_Image.image,
                }
                if (title.includes("services")) {
                    servicesObj = obj
                } else if (title.includes("team")) {
                    ourTeamObj = obj
                }
            }

            return null
        })

    return (
        <PageWrapper>
            <HomepageBanner data={banner} />
            <Journey />
            <OurServices data={servicesObj} />
            <WhatsNew data={dataWhatsnew} description={whatNewsDesc} />
            <OurTeam data={ourTeamObj} />
            <Resources data={resources} description={resourcesDesc} />
            <OurCompany description={companyDesc} />
        </PageWrapper>
    )
}

export default IndexPage
